export default __webpack_public_path__ + "static/media/058-black panther.205b4c93.svg";